import { FEEDBACK_DOWNLOADED, FEEDBACK_FAILED, FEEDBACK_PENDING } from './types';

export const INITIAL_STATE = {
  error: null,
  content: null,
  pending: false,
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case FEEDBACK_PENDING:
      return {
        ...state,
        pending: true,
      };
    case FEEDBACK_FAILED:
      return {
        ...state,
        pending: false,
        error: action.payload.error,
      };

    case FEEDBACK_DOWNLOADED:
      return {
        ...state,
        pending: false,
        content: action.payload.content,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/feedbacks/reducers.js